module.exports = __webpack_public_path__ + "static/poligono5_03-766039450ca6c3ab96e6c5f02c03106a.jpg";